module.exports = __webpack_public_path__ + "static/img/bg-overview@t.716c57b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-chem-pr-portal/bg-overview@t.jpg
// module id = LHys
// module chunks = 0